import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-22a1d0f4"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrapper" };
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "tip" }, "申请后会给您邮寄纸质报告，需要到付哦", -1); });
var _hoisted_3 = /*#__PURE__*/ _createTextVNode("立即申请");
var _hoisted_4 = { class: "overlay-wrapper" };
import { Toast } from "vant";
import { ref } from "vue";
import { requsetPaper } from "@/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'requestPaper',
    props: {
        reportReceivingAddress: {
            type: String,
            default: "样本报告详情",
        },
        reportReceivingEmail: {
            type: String,
            required: true,
        },
        orderId: {
            type: String,
            required: true,
        },
        reportId: {
            type: String,
            required: true,
        },
        patientId: {
            type: String,
            required: true,
        },
    },
    emits: ["cancel", "ok"],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var props = __props;
        var formRef = ref();
        var handleCancel = function () {
            sessionStorage.removeItem("reportUrl");
            emit("cancel");
        };
        var loadingVisible = ref(false);
        var handleQequestPaper = function () {
            formRef.value.validate().then(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    loadingVisible.value = true;
                    requsetPaper({
                        orderId: props.orderId,
                        reportId: props.reportId,
                        patientId: props.patientId,
                        reportReceivingAddress: address.value,
                        reportReceivingEmail: email.value,
                    })
                        .finally(function () { return (loadingVisible.value = false); })
                        .then(function (res) {
                        if (res.code === 200) {
                            Toast("申请成功！");
                            emit("ok");
                        }
                        else {
                            Toast(res.message);
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
        };
        var address = ref(props.reportReceivingAddress);
        var email = ref(props.reportReceivingEmail);
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_field = _resolveComponent("van-field");
            var _component_van_form = _resolveComponent("van-form");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "申请纸质报告",
                    onClickLeft: handleCancel
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createVNode(_component_van_form, {
                    ref_key: "formRef",
                    ref: formRef
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_van_field, {
                            style: _normalizeStyle({ marginTop: '0.16rem' }),
                            modelValue: address.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((address).value = $event); }),
                            label: "报告接收地址",
                            placeholder: "请输入报告接收地址",
                            rules: [{ required: true, message: '请输入报告接收地址' }]
                        }, null, 8, ["style", "modelValue"]),
                        _createVNode(_component_van_field, {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((email).value = $event); }),
                            label: "报告接收邮箱",
                            placeholder: "请输入报告接收邮箱",
                            rules: [{ required: true, message: '请输入报告接收邮箱' }]
                        }, null, 8, ["modelValue"])
                    ]; }),
                    _: 1
                }, 512),
                _hoisted_2,
                _createElementVNode("div", {
                    style: _normalizeStyle({
                        position: 'fixed',
                        left: 0,
                        bottom: 0,
                        boxSizing: 'border-box',
                        padding: '0.32rem',
                        width: '100%',
                    })
                }, [
                    _createVNode(_component_van_button, {
                        color: "#3DABA4",
                        round: "",
                        block: "",
                        onClick: handleQequestPaper
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_3
                        ]; }),
                        _: 1
                    })
                ], 4),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
